const GOLD_BOX_STATUS= {
    virtualBox: {title: 'در صندوقچه', type: 'info'},
    preparing: {title: 'در حال آماده‌سازی', type: 'info'},
    inGoldBox: {title: 'آماده تحویل', type: 'info'},
    delivered: {title: 'تحویل شده', type: 'success'},
    waitingForReturn: {title: 'در انتظار برگشت', type: 'error'},
    returned: {title: 'برگشته', type: 'info'},
}
export {GOLD_BOX_STATUS}